import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

interface DeleteConsentDialogProps {
  open: any;
  onClose: any;
  onConfirm: any;
  itemName: any;
  itemDetails?: any;
  loading?: boolean;
  [key: string]: any;
}

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: 8,
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
  },
  dialogTitle: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    padding: 10,
  },
  dialogContent: {
    padding: 10,
  },
  dialogActions: {
    padding: 15,
  },
  cancelButton: {
    color: theme.palette.text.secondary,
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

const DeleteConsentDialog = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemDetails,
  loading = false,
  ...props
}: DeleteConsentDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        Confirm {props.btnText ? props.btnText : " Deletion"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography style={{ padding: "5px 10px" }}>
          {props?.message ? props?.message : "Are you sure you want to delete "}
          <i style={{ fontWeight: "bold" }}>{itemName}</i>?
        </Typography>
        {itemDetails && (
          <Typography style={{ padding: "5px 10px", fontSize: "14px", color: "#666" }}>
            {itemDetails}
          </Typography>
        )}
        <Typography style={{ padding: "5px 10px" }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={onClose} className={classes.cancelButton}>
          Cancel
        </Button>
        <Button onClick={onConfirm} className={classes.deleteButton} autoFocus disabled={loading}>
          {props?.btnText ? props?.btnText : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConsentDialog;
